import { EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { SessionStorageService } from 'ngx-webstorage';
import { Observable, ReplaySubject, of } from 'rxjs';
import { shareReplay, tap, catchError, map } from 'rxjs/operators';

import { ApplicationConfigService } from '../config/application-config.service';
import { Account } from '../models/account.model';
import { StateStorageService } from '../config/state-storage.service';
import { createRequestOption } from '../request/request-util';


@Injectable({ providedIn: 'root' })
export class AccountService {
  public userIdentity: Account | null = null;
  private authenticationState = new ReplaySubject<Account | null>(1);
  private accountCache$?: Observable<Account | null>;
  constructor(
    private sessionStorage: SessionStorageService,
    private http: HttpClient,
    private stateStorageService: StateStorageService,
    private router: Router,
    private applicationConfigService: ApplicationConfigService
  ) { }

  protected resourceUrl = this.applicationConfigService.getEndpointFor('api/admin');

  save(account: Account): Observable<{}> {
    return this.http.post(this.applicationConfigService.getEndpointFor('api/account'), account);
  }

  authenticate(identity: Account | null): void {
    this.userIdentity = identity;
    this.authenticationState.next(this.userIdentity);
  }

  hasAnyAuthority(authorities: string[] | string): boolean {
    if (!this.userIdentity) {
      return false;
    }
    if (!Array.isArray(authorities)) {
      authorities = [authorities];
    }
    return this.userIdentity.authorities.some((authority: string) => authorities.includes(authority));
  }

  identity(force?: boolean): Observable<Account | null> {

    if (!this.accountCache$ || force || !this.isAuthenticated()) {
      this.accountCache$ = this.fetch().pipe(
        catchError(() => of(null)),
        tap((account: Account | null) => {
          this.authenticate(account);
        }),
        shareReplay()
      );
    }

    return this.accountCache$;
  }

  isAuthenticated(): boolean {
    return this.userIdentity !== null;
  }

  getAuthenticationState(): Observable<Account | null> {
    return this.authenticationState.asObservable();
  }

  getImageUrl(): string {
    return this.userIdentity?.imageUrl ?? '';
  }

  query(): Observable<HttpResponse<Account[]>> {
    return this.http.get<Account[]>(`${this.resourceUrl}/users`, { observe: 'response' });
  }

  sendEmailNotAcceptTermos(id:any){
    this.http
      .get<void>(`${this.resourceUrl}/send-email-not-accept/${id}`, { observe: 'response' })
      .pipe(map(() => console.log));
  }


  getAllNotAccepTermos(res?: any): Observable<any> {
    const options = createRequestOption(res);
    return this.http.get<Account[]>(`${this.resourceUrl}/users/allnotaccepttermos`, {  params: options,observe: 'response' });
  }

  private fetch(): Observable<Account> {
    let account = this.http.get<Account>(this.applicationConfigService.getEndpointFor('api/account'));
    return account;
  }

  private navigateToStoredUrl(): void {
    // previousState can be set in the authExpiredInterceptor and in the userRouteAccessService
    // if login is successful, go to stored previousState and clear previousState
    const previousUrl = this.stateStorageService.getUrl();
    if (previousUrl) {
      this.stateStorageService.clearUrl();
      this.router.navigateByUrl(previousUrl);
    }

  }
}




